import { createSvgIcon } from "./create-svg-icon";

export const CircledBurgerMenu = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <g transform="matrix(2,0,0,2,0,0)">
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}",
          }}
        />
      </defs>
      <title>navigation-menu-3</title>
      <circle className="a" cx={12} cy="12.003" r="11.25" />
      <line className="a" x1="7.5" y1="8.253" x2="16.5" y2="8.253" />
      <line className="a" x1="7.5" y1="12.003" x2="16.5" y2="12.003" />
      <line className="a" x1="7.5" y1="15.753" x2="16.5" y2="15.753" />
    </g>
  </svg>,
);
